import { useAppSelector } from '.';
import { getIsVerticalNavPinned } from '../NavLayoutDimensions/selectors';
const useIsVerticalNavPinned = () => {
  const isVerticalNavPinned = useAppSelector(getIsVerticalNavPinned);
  return isVerticalNavPinned;
};
export default useIsVerticalNavPinned;